class CrystaChat {
    public static scrollToLastChatBox(containerId: string): void {
        const container = document.getElementById(containerId);
        if (!container) return;

        const suggestionsContainer = document.querySelector('.chat-with-suggestions-container') as HTMLElement;
        const suggestionsHeight = suggestionsContainer?.clientHeight || 0;

        const chatBoxes = container.getElementsByClassName('ai-chat-box');
        if (chatBoxes.length === 0) return;

        const lastChatBox = chatBoxes[chatBoxes.length - 1] as HTMLElement;

        const containerRect = container.getBoundingClientRect();
        const chatBoxRect = lastChatBox.getBoundingClientRect();
        const relativeTop = chatBoxRect.top - containerRect.top;
        const containerHeight = container.clientHeight - suggestionsHeight;
        const chatBoxHeight = chatBoxRect.height;

        if (chatBoxHeight > containerHeight) {
            container.scrollTo({
                top: relativeTop + container.scrollTop - 150,
                behavior: 'smooth'
            });
        } else {
            const scrollPosition = relativeTop + container.scrollTop - (containerHeight - chatBoxHeight);
            container.scrollTo({
                top: scrollPosition,
                behavior: 'smooth'
            });
        }
    }
}


(window as any).CrystaChat = CrystaChat;
